var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-flex h-100 flex-fill flex-column"},[_c('Logo',{staticClass:"agriplus-logo mt-2 mb-5"}),_c('router-view',{staticClass:"flex-fill"}),_c('Footer',{staticClass:"mt-2"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }